module.exports = __webpack_public_path__ + "img/title1.73aa470e.png";